















































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({})
export default class LetEditable extends Vue {
    @Prop({ required:true }) item!:any | null;
    @Prop({ default:"12" }) md!:string;
    @Prop({ default:"" }) label!:string;
    @Prop({ default:"text" }) type!:string;
    @Prop({ required:true }) propName!:string;
    @Prop({ required:true }) action!:string;
    @Watch('item')
    onPropertyChanged(value: any, oldValue: any) {
        //console.log("item leteditable",oldValue,value);
        //Bu bozulursa buraya bak binding de sorun vardi product group da boyle cozdum.
        this.value = value[this.propName];
    }
    prevValue:string="";
    value:string="";
    spinner = false;
    created(){
        this.value = this.item[this.propName];
        this.prevValue = this.value;
    }
    snack:boolean= false;
    save () {
        this.snack = true
    }
    cancel () {
        this.snack = true
    }
    open () {
        this.snack = true
    }
    serialize (obj:any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }
    async close () {
        if(this.prevValue == this.value){
            return;
        }
        //this.item[this.propName] = this.value
        this.spinner = true;
        this.prevValue = this.value;
        var requestPayload:any = {};
        requestPayload[this.propName] = this.value;
        let response = await Vue.prototype.$http.request({
            method:"PATCH",
            url:this.action+"?"+this.serialize(requestPayload),
            transformRequest:[function (data:any, headers:any) {
                //console.log("transform here",data);
                return data;
            }]
        });
        if(typeof response.data != "object" || response.status != 200){
            this.value = this.prevValue;
            alert("Lütfen geçerli bir değer giriniz.")
        }
        this.$emit("success",true);
        this.spinner = false;
        //let response = await Vue.prototype.$http.patch(this.action + "?"+this.propName+"=",requestPayload);
    }
}
